import React, {useEffect, useRef} from "react";
import PropTypes from "prop-types";
import { Popup } from "maplibre-gl"
import "./popup.css"

const MapTreePopupLayer = ({map, treeModel, onClose, onInfo}) => {

    const popupRef = useRef()

    useEffect(() => {
        map?.on("click", () => {
            popupRef.current?.remove()
            popupRef.current = null
            onClose()
        })
    }, [map])

    useEffect(() => {
        console.log("[Popup]", "tree model", treeModel)
        if (!map || !treeModel) {
            popupRef.current?.remove()
            popupRef.current = null
            return
        }

        const div = document.createElement("div")
        div.className = "tree-popup-content"

        if (treeModel.tree_id) {
            const treeIdDiv = document.createElement("div")
            treeIdDiv.innerText = treeModel.tree_id
            treeIdDiv.className = "tree_id"
            div.appendChild(treeIdDiv)
        }


        if (treeModel.type) {
            const typeDiv = document.createElement("div")
            typeDiv.innerText = treeModel.type
            typeDiv.className = "tree_type"
            div.appendChild(typeDiv)
        }

        if (treeModel.type !== "高木中木無") {
            const titleDiv = document.createElement("div")
            titleDiv.innerText = treeModel.name ?? "種名未設定"
            titleDiv.className = "tree_name"
            div.appendChild(titleDiv)
        }


        console.log(div, treeModel)

        if (treeModel.tree_uid) {
            const infoLink = document.createElement("a")
            infoLink.className = "tree_info_link"
            infoLink.href = "#"
            infoLink.onclick = () => {
                onInfo(treeModel)
            }
            infoLink.innerText = "詳細表示"
            div.appendChild(infoLink)
        }

        let popup = new Popup()
            .setLngLat({lng: treeModel.longitude, lat: treeModel.latitude})
            .setDOMContent(div)
            .addTo(map)
        console.log(popup)

        popup.on("close", () => {
            onClose()
        })

        popupRef.current = popup



        // return () => {
        //     popupRef.current?.remove()
        //     popupRef.current = null
        // }
    }, [map, treeModel])

    return null
}

MapTreePopupLayer.propTypes = {
    map: PropTypes.any,
    onClose: PropTypes.func,
    onInfo: PropTypes.func,
    treeModel: PropTypes.object,
}

export default MapTreePopupLayer
